import { render, staticRenderFns } from "./mainInfo.vue?vue&type=template&id=74c54388&"
import script from "./mainInfo.vue?vue&type=script&lang=js&"
export * from "./mainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports